import React, { FC, forwardRef } from "react";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import "./phonefiled.scss";


// interface to declare all our prop types
export type Props = {
  country?: string;
  name?: string;
  value?: string;
  defaultChecked?: boolean;
  disabled?: boolean;
  handleChange?: any;
  onChange?: any
  inputProps:any
}

export const PhoneFiled: FC<Props> = forwardRef<HTMLInputElement, Props>(
  ({
  country = '',
  name = '',
  value = '',
  defaultChecked,
  disabled,
  onChange,
  inputProps,
  
  ...rest
}, ref) => {
  return (
    <div className="phonefiled">
      <PhoneInput country={country} value={value}
        inputProps={inputProps}
        disabled={disabled}
        countryCodeEditable={false}
        onChange={onChange} 
        copyNumbersOnly={true}
        />
    </div>
  );
}
)

export default PhoneFiled;

